import request from "@/method/request";
import { Button, message, Row, Radio, Table } from 'antd';
import FileSaver from "file-saver";
import _ from 'lodash';
import { inject, observer } from "mobx-react";
import moment from 'moment';
import React, { Component } from 'react';
import Auth from "../../Auth";
import imgSave from "../../saveImg";
import TableText from "@/components/table/TableText";

const totalIndex = [];

@inject('store')
@observer
class index extends Component {
    state = {
        data: [],
        loading: true,
        loadingSave: false,
        print: false,
        type: 1
    }

    componentDidMount() {
        this.getData();
    }
    getData = async () => {
        const { type } = this.state;
        try {
            this.setState({ loading: true });
            const x = await request(`/api/systemStatisticalInfo?type=${type}`);
            let data;
            if (type == 1) data = [x.data || { pms: "", pmsPrice: 0, fmis: "", fmisPrice: 0 }]
            if (type == 2) data = x.data;

            this.setState({ loading: false, data })
        } catch (err) {
            this.setState({ loading: false });
            console.error(err);
        }
    }

    onSave = async () => {

        try {
            const { type, data } = this.state;
            if (type == 2) return;
            this.setState({ loadingSave: true });

            let dataFrom = new FormData();
            dataFrom.append('data', JSON.stringify(data));
            let headres = {
                method: 'post',
                credentials: 'include',
                headers: {},
                body: dataFrom
            }

            const x = await request('/api/systemStatisticalSave', headres);
            let timer = setTimeout(() => { this.setState({ loadingSave: false }); clearTimeout(timer) }, 1000)
            if (x.status == 1) {
                message.success(x.msg);
                if (!data[0].id) {
                    this.getData();
                }
                return
            }
            message.error(x.msg);
        } catch (err) {
            let timer = setTimeout(() => { this.setState({ loadingSave: false }); clearTimeout(timer) }, 1000)
            console.error(err);
            message.error('保存失败' + JSON.stringify(err));
        }
    }

    downloadSG = () => {

        this.setState({ print: true, loading: true }, () => {
            imgSave('view4_1_4', 1.5, '7.7', this.state.date).then(x => {
                if (x.status == 1) {
                    message.info('添加成功！');
                } else {
                    message.error('添加失败' + x.msg);
                }

                this.setState({
                    print: false,
                    loading: false
                });
            }).catch(err => {
                console.error(err);
                this.setState({
                    print: false,
                    loading: false
                });
            })

        });
    }

    downloadExcel = () => {
        const tableName = `${moment(this.state.date).format('YYYY')} 酒店系统统计`
        const innerHtml = `
          <caption>${tableName}</caption>
          ${document.getElementById('table4_1_4').innerHTML.replace(/<table class="">/g, '<table border="1">')}
        `;

        var html = "<html><head><meta charset='utf-8' /></head><body>" + innerHtml + "</body></html>";
        var blob = new Blob([html], { type: "application/vnd.ms-excel" });
        FileSaver.saveAs(blob, `${(tableName)}.xls`);
        this.setState({ print: false });
    }

    render() {
        const { data, print, loading, type } = this.state;
        const { user } = this.props.store.auth;
        return (
            <div className="table7_1_1 tableHeight" style={{ width: 1200 }} >
                <Row className="title" id="view4_1_4" >
                    <Row>酒店系统统计</Row>
                    {user.email === 'admin' && <Radio.Group onChange={e => {
                        this.setState({ type: e.target.value }, () => {
                            this.getData()
                        })
                    }} value={type}>
                        <Radio value={1}>单体酒店</Radio>
                        <Radio value={2}>全部酒店</Radio>
                    </Radio.Group>}
                </Row>
                <Table
                    columns={[{
                        title: '',
                        dataIndex: 'name',
                        key: 'name',
                        align: "center",
                        width: 300,
                        render: (text, record, index) => {
                            const props = {
                                text,
                                index,
                                type: 'text',
                                name: "name",
                                totalIndex,
                            };
                            return <TableText data={props} />
                        }
                    },
                    {
                        title: `PMS系统名称`,
                        dataIndex: 'pms',
                        key: 'pms',
                        align: "center",
                        width: 200,
                        render: (text, record, index) => {
                            const props = {
                                text,
                                index,
                                type: !totalIndex.includes(index) && type == 1 && !print ? 'input' : 'text',
                                name: "pms",
                                onChange: (name, value, index) => {
                                    let _data = [...data];
                                    _data[index][name] = value;
                                    this.setState({ data: _data })
                                },
                                totalIndex,
                            };
                            if (!totalIndex.includes(index)) return <TableText data={props} />
                        }
                    },
                    {
                        title: `年维护费`,
                        dataIndex: 'pmsPrice',
                        key: 'pmsPrice',
                        align: "center",
                        width: 200,
                        render: (text, record, index) => {
                            const props = {
                                text,
                                index,
                                type: !totalIndex.includes(index) && type == 1 && !print ? 'inputNumber' : 'number',
                                name: "pmsPrice",
                                onChange: (name, value, index) => {
                                    let _data = [...data];
                                    _data[index][name] = value;
                                    this.setState({ data: _data })
                                },
                                totalIndex,
                            };
                            if (!totalIndex.includes(index)) return <TableText data={props} />
                        }
                    },
                    {
                        title: `财务系统名称`,
                        dataIndex: 'fmis',
                        key: 'fmis',
                        align: "center",
                        width: 200,
                        render: (text, record, index) => {
                            const props = {
                                text,
                                index,
                                type: !totalIndex.includes(index) && type == 1 && !print ? 'input' : 'text',
                                name: "fmis",
                                onChange: (name, value, index) => {
                                    let _data = [...data];
                                    _data[index][name] = value;
                                    this.setState({ data: _data })
                                },
                                totalIndex,
                            };
                            if (!totalIndex.includes(index)) return <TableText data={props} />
                        }
                    },
                    {
                        title: `年维护费`,
                        dataIndex: 'fmisPrice',
                        key: 'fmisPrice',
                        align: "center",
                        width: 200,
                        render: (text, record, index) => {
                            const props = {
                                text,
                                index,
                                type: !totalIndex.includes(index) && type == 1 && !print ? 'inputNumber' : 'number',
                                name: "fmisPrice",
                                onChange: (name, value, index) => {
                                    let _data = [...data];
                                    _data[index][name] = value;
                                    this.setState({ data: _data })
                                },
                                totalIndex,
                            };
                            if (!totalIndex.includes(index)) return <TableText data={props} />
                        }
                    }]}
                    dataSource={data}
                    size="middle"
                    id="table4_1_4"
                    bordered
                    loading={loading}
                    pagination={false}
                    rowClassName="protruding"
                    className="content"
                    scroll={print ? {} : { y: 500 }}
                    rowKey={(record, index) => index}
                />
                <Row className="table-footer-btn">
                    <Button
                        type="primary"
                        onClick={() => {
                            this.setState({ print: true }, () => {
                                this.downloadExcel();
                            });
                        }}
                        style={{ marginRight: 10 }}
                        loading={print}
                    >导出Excel</Button>
                    <Auth loading={this.state.loading} auth="edit_systemStatistical">
                        <Button
                            type="primary"
                            onClick={this.onSave}
                            loading={this.state.loadingSave}
                        >保存</Button>
                    </Auth>
                </Row>
            </div>
        );
    }
}

export default index;



// WEBPACK FOOTER //
// ./src/components/table/other/systemStatistical/index.js